import axios from '../../config/axios-interceptor';
import i18n from '../../i18n';

export const LOGIN = '[AUTH] LOGIN';
export const LOGIN_SUCCESS = '[AUTH] LOGIN_SUCCESS';
export const LOGIN_FAIL = '[AUTH] LOGIN_FAIL';
export const LOGOUT = '[AUTH] LOGOUT';
export const USER = '[AUTH] USER';
export const PROVIDERS = '[AUTH] PROVIDERS';

export const authenticate = (body) => {
  return async dispatch => {
    dispatch({type: LOGIN});

    try {
      const response = await axios.post('Account/authenticate', body);

      if (response?.data?.succeeded) {
        localStorage.setItem('token', response?.data?.data?.jwToken);
        dispatch({type: LOGIN_SUCCESS});
      } else {
        dispatch({type: LOGIN_FAIL, payload: i18n.t('somethingWentWrong')});
      }
    } catch (err) {
      dispatch({type: LOGIN_FAIL, payload: i18n.t('somethingWentWrong')});
    }
  }
}


export const user = () => {
  return async dispatch => {
    try {
      const response = await axios.get('Calendar/GetUser');


        dispatch({type: USER, payload: response.data});

    } catch (err) {
      console.log(err);
    }
  }
}

export const providers = () => {
  return async dispatch => {
    try {
      const response = await axios.get('Account/getexternalproviders');

      dispatch({type: PROVIDERS, payload: response.data});

    } catch (err) {
      console.log(err);
    }
  }
}

export const loginExternalUser = (body) => {
  return async dispatch => {
    dispatch({type: LOGIN});

    try {
      const response = await axios.post('Account/LoginExternalUser', body);
      
      if (response?.data?.succeeded) {
        localStorage.setItem('token', response?.data?.data?.jwToken);
        dispatch({type: LOGIN_SUCCESS});
      } else {
        dispatch({type: LOGIN_FAIL, payload: i18n.t('somethingWentWrong')});
      }
    } catch (err) {
      dispatch({type: LOGIN_FAIL, payload: i18n.t('somethingWentWrong')});
    }
  }
}



export const logout = () => {
  return async dispatch => {
    localStorage.removeItem('token');
    dispatch({type: LOGOUT});
  }
}
